import { ReactElement } from 'react';

type SearchInputProps = {
  textValue: string;
  setText: (inp: string) => void;
  placeholder?: string;
};

/**
 * A common Search control component which supports multiple Search types.
 * @param props - SearchInput props.
 * @returns - Returns a react element for search text.
 */
export default function SearchInput(props: SearchInputProps): ReactElement {
  const { textValue, placeholder = 'Search', setText } = props;
  return (
    <div className="relative w-full">
      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <span className="text-gray-500 material-icons-outlined text-xl">search</span>
      </div>
      <input
        type="search"
        id="default-search"
        className="block shadow-xs w-full py-1.5 pl-11 pr-3.5 h-9 text-base text-gray-700 dark:text-gray-300 placeholder-gray-500 border border-gray-300 dark:border-gray-700 rounded bg-gray-50 dark:bg-container-500 focus:dark:border-primary-300 focus-within:dark:ring-transparent"
        placeholder={placeholder}
        value={textValue}
        onChange={(event) => setText(event.target.value)}
      />
    </div>
  );
}
